'use strict';

(function ($) {
    $.fn.tpsFancyFileInput = function () {
        var $input = $(this),
            $text = $input.prevAll('.tps-fancy-input-file-text');

        $input.on('change', function (e) {
            var fileName = '';

            if (this.files && this.files.length > 1) {
                fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
            } else if (e.target.value) {
                fileName = e.target.value.split('\\').pop();
            }

            if (fileName) {
                $text.val(fileName);
            } else {
                $text.val('');
            }
        });

        // Firefox bug fix
        $input
            .on('focus', function () { $input.addClass('has-focus'); })
            .on('blur', function () { $input.removeClass('has-focus'); });

        return this;
    };
})(window.jQuery);
